import { PlusOutlined } from "@ant-design/icons";
import { Button, Checkbox, Col, DatePicker, Flex, Form, Input, Row, Select, Typography, Upload, message } from "antd";
import React, { useEffect, useState } from "react";
import AxiosService from "../services/APIService";
import { connect } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import ContactInput from "../components/ContactInput";
import country from "../data/country";
import lightLogo from "../assets/sidebarLogo.png";
import { fileSizeValidation } from "../utils/commonFunc";
import axios from "axios";

function UserRegistration({isLoading}) {
    const navigate = useNavigate()
    const [isChecked,setIsChecked] = useState(false);
    const [form] = Form.useForm()
    const apiService = new AxiosService()
    const [userPreference,setuserPreference] = useState("Mr.");
    const [searchParams] = useSearchParams();
    const wlId = searchParams.get("wlid")
    const [formInitData,setFormInitData] = useState(null);
    const [whiteLabel,setWhiteLabel] = useState(null);

    const [formExtender,setFormExtender] = useState(false);
    const [fileList,setFileList] = useState([]);

    useEffect(() => {
        fetchFormData()
    },[]);
    const fetchFormData = () => {
        apiService.get("/form-data",{wlId})
            .then(res => {
                setFormInitData(res.data)
            })
            .catch(e => {
                console.log(e);
            })
    }

    const formSubmit = (val) => {
        // if(val.docs.fileList.length === 0) {
        //     message.error("Please upload at least 1 Document.")
        //     return
        // }
        const formData = new FormData()
        formData.append("fullName",val?.fullname || '')
        if(val?.phoneNo) formData.append("phone_no",val?.phoneNo)
        formData.append("whatsapp_no",val?.whatsappNo)
        // formData.append("street",val?.street)
        formData.append("city",val?.city)
        formData.append("state",val?.state)
        formData.append("country",val?.country)
        // formData.append("pincode",val?.pincode)
        formData.append("email",val?.username)
        formData.append("business_email",val?.email)
        formData.append("dob",val?.dob)
        formData.append("password",val?.password)
        formData.append("reference_by",val?.refName)
        formData.append("pref",val?.prefix || 'Mr')
        formData.append("risk_pr",val.risk_pr)
        // val.docs.fileList.forEach((fl,i) => {
        //     formData.append(`doc${i}`,fl.originFileObj)
        // });

        if(formExtender || wlId) {
            formData.append("broker_name",val?.brokerName)
            formData.append("account_number",val?.accountNumber)
            formData.append("master_password",val?.masterPassword)
            formData.append("investor_password",val?.investorPassword)
            // formData.append("portal_link",val?.portalLink)
            // formData.append("portal_password",val?.portalPassword)
            formData.append("server",val?.brokerServer)
            if(val?.vpsServer) formData.append("server_vps",val?.vpsServer)
        }

    if (wlId) formData.append("white_label", wlId);
    let apiUrl = wlId ? "auth/create-wluser" : "auth/register";
    apiService
      .post(apiUrl, formData)
      .then((res) => {
        message.success(`Register Successfully`);
        if (val?.depositAmount) {
          const formField = new FormData();
          formField.append("amount", val.depositAmount);
          formField.append("type", "DEPOSIT");
          axios
            .post(`${process.env.REACT_APP_API_URL}transaction/create-by-user`, formField, {
              headers: {
                Authorization: `Bearer ${res?.token}`,
              },
            })
            .then((res) => {
              form.resetFields();
            //   message.success(res.data?.message || "Deposit created successfully!");
            })
            .catch((e) => {
              message.error(e.response?.data?.message || e.message);
            });
        }
        form.resetFields();
        navigate(wlId ? `/login/customer?white_label=${wlId}` : "/login/customer");
      })
      .catch((e) => message.error("Something went wrong"));
  };

    useEffect(() => {
            if(wlId) {
                fetchWhitelabel()
            }
        },[wlId]);
        const fetchWhitelabel = () => {
            apiService.get(`white-label/get/${wlId}`)
            .then(res => {
                setWhiteLabel(res.data)
            })
            .catch(e => console.log(e))
        }
    const handleChange = ({fileList: newFileList}) => setFileList(newFileList);
    const uploadButton = (
        <button
            style={{
                border: 0,
                background: 'none',
            }}
            type="button"
        >
            <PlusOutlined />
            <div
                style={{
                    marginTop: 8,
                }}
            >
                Upload
            </div>
        </button>
    );

    return (
        <>
            <div className='lead-container'>
                <div className='lead-content'>
                    <div className='logo-wrapper'>
                    {wlId ?
                    <div style={{textAlign: "center", marginBottom: 20, paddingTop: 24, backgroundColor: "rgb(19, 28, 43)"}}>
                        <img src={`${process.env.REACT_APP_API_URL}white-label/logo/${wlId}`} style={{width: "20%", margin: "auto"}} /> 
                    </div>: <div style={{textAlign: "center", marginTop: -1, backgroundColor: "rgb(19, 28, 43)"}}>
                        <img src={lightLogo} style={{width: "200px", margin: "auto"}} /> 
                    </div>}
                    </div>
                    <div className='lead-logo-wrapper'>
                        <p>Please fill in your details below to complete your registration.</p>
                    </div>
                    <div className='lead-form-block'>
                        <div className='form-block'>
                            <Form
                                name="lead"
                                onFinish={formSubmit}
                                autoComplete="off"
                                layout='vertical'
                                form={form}
                            >
                                <Row gutter={20}>
                                    <Col sm={5} xs={8}>
                                        <Form.Item
                                            label="Prefix"
                                            name="prefix"
                                        >
                                            <Select
                                                placeholder="Select a Option"
                                                defaultValue="Mr"
                                                size='large'
                                                options={[
                                                    {
                                                        value: 'Mr',
                                                        label: 'Mr',
                                                    },
                                                    {
                                                        value: 'Ms',
                                                        label: 'Ms',
                                                    },
                                                    {
                                                        value: 'Mrs',
                                                        label: 'Mrs',
                                                    },
                                                ]}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col sm={19} xs={16}>
                                        <Form.Item
                                            label="Full Name"
                                            name="fullname"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please Enter Name',
                                                },
                                            ]}
                                        >
                                            <Input size='large' placeholder='Enter your full name' />
                                        </Form.Item>
                                    </Col>
                                    <Col sm={24} xs={24}>
                                        <Form.Item
                                            label="Email Address"
                                            name="email"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please Enter Email',
                                                    type: "email"
                                                }
                                            ]}
                                        >
                                            <Input size='large' placeholder='Enter your email' />
                                        </Form.Item>
                                    </Col>
                                    <Col sm={24} xs={24}>
                                        <Row gutter={16}>
                                            {/* <Col span={10}>
                                                <Form.Item label="Street" name={"street"} rules={[{required: true,message: 'Please Enter Street!'}]}>
                                                    <Input size='large' placeholder="Street" />
                                                </Form.Item>
                                            </Col> */}
                                            <Col span={24}>
                                                <Row gutter={16}>
                                                    <Col sm={8} xs={24}>
                                                        <Form.Item label="City" name={"city"} rules={[{required: true,message: 'Please Enter City!'}]}>
                                                            <Input size='large' placeholder="City" />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col sm={8} xs={24}>
                                                        <Form.Item label="State" name={"state"} rules={[{required: true,message: 'Please Enter State!'}]}>
                                                            <Input size='large' placeholder="State" />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col sm={8} xs={24}>
                                                        <Form.Item
                                                            label="Country"
                                                            name="country"
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: 'Please Select Country',
                                                                },
                                                            ]}
                                                        >
                                                            <Select
                                                                showSearch
                                                                size='large'
                                                                placeholder="Select a Country"
                                                                options={[...new Set(country.map(item => item.name))].map(ctr => ({
                                                                    value: ctr,
                                                                    label: ctr,
                                                                }))}
                                                                filterOption={(input,option) =>
                                                                    option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                                                                    option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                            />
                                                        </Form.Item>
                                                    </Col>
                                                    {/* <Col span={12}>
                                                        <Form.Item label="Pincode" name={"pincode"} rules={[{required: true,message: 'Please Enter Pincode!'}]}>
                                                            <Input size='large' placeholder="Pincode" />
                                                        </Form.Item>
                                                    </Col> */}
                                                </Row>
                                            </Col>

                                        </Row>
                                    </Col>
                                    {!wlId && <Col span={12}>
                                        <Form.Item label="Reference by (Name)" name="refName">
                                            <Select size='large' placeholder="Select Customer" showSearch options={formInitData?.users?.map(cst => ({
                                                value: cst?.user?._id,
                                                label: cst?.user?.fullName
                                            }))} filterOption={(input,option) =>
                                                option?.label?.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                                                option?.value?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            } />
                                        </Form.Item>
                                    </Col>}
                                    <Col span={!wlId ? 12 : 24}>
                                        <Form.Item label="Date of Birth" name="dob" rules={[{required: true,message: 'Please select date of birth!'}]}>
                                            <DatePicker size='large' style={{width: '100%'}} format={{
                                                format: "DD-MM-YYYY",
                                                type: "mask"
                                            }} />
                                        </Form.Item>
                                    </Col>
                                    <Col sm={12} xs={24}>
                                        <ContactInput form={form} name='phoneNo' label='Phone No.' />
                                    </Col>
                                    <Col sm={12} xs={24}>
                                        <ContactInput form={form} name='whatsappNo' label='Whatsapp No.' require={true} />
                                    </Col>
                                    {/* <Col span={24}>
                                        <Form.Item label="Document (Upload your National Identification Document in less then 2mb)" name="docs" rules={[{required: true,message: 'Documents requires'}]}>
                                            <Upload
                                                listType="picture-card"
                                                fileList={fileList}
                                                onChange={handleChange}
                                                beforeUpload={fileSizeValidation}
                                                accept=".pdf, .jpg, .jpeg, .png"
                                            >
                                                {fileList.length >= 8 ? null : uploadButton}
                                            </Upload>
                                        </Form.Item>
                                    </Col> */}
                                    <Col span={24}>
                                        <Form.Item label="User Name (Email id)" name="username" rules={[{required: true,type: 'email',message: 'Please Enter valid email address!'}]}>
                                            <Input size='large' placeholder="Enter User Name" />
                                        </Form.Item>
                                    </Col>
                                    <Col sm={12} xs={24}>
                                        <Form.Item label="Password (user)" name="password" rules={[{required: true,message: 'Please Enter password!'}]}>
                                            <Input.Password size='large' placeholder="Enter Password" />
                                        </Form.Item>
                                    </Col>
                                    <Col sm={12} xs={24}>
                                        <Form.Item label="User Confirm Password" name="confirmPassword" dependencies={['password']} rules={[
                                            {
                                                required: true,
                                                message: 'Please confirm password!',
                                            },
                                            ({getFieldValue}) => ({
                                                validator(_,value) {
                                                    if(!value || getFieldValue('password') === value) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(new Error('The new password that you entered do not match!'));
                                                },
                                            }),
                                        ]}>
                                            <Input.Password size='large' placeholder="Confirm Password" />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        {!wlId && <Flex align='center' style={{marginBottom: 15}}>
                                            <span>Have Server Details?</span> &nbsp;
                                            <Checkbox value={formExtender} onChange={(e) => setFormExtender(e.target.checked)} />
                                        </Flex>}
                                    </Col>
                                    {(formExtender || wlId) &&
                                        <>
                                            <Col sm={24} xs={24}>
                                                <Typography.Title level={5}>MT5 ACCOUNT DETAILS</Typography.Title>
                                            </Col>
                                            <Col sm={12} xs={24}>
                                                <Form.Item label="Broker Name" name="brokerName" rules={[{required: true,message: 'Please Enter broker name!'}]}>
                                                    {/* <Select
                                                        placeholder="Select Broker"
                                                        onChange={(val,dt) => {
                                                            form.setFieldValue("brokerServer",dt.server)
                                                            form.setFieldValue("portalLink",dt.link)
                                                        }}
                                                        size='large'
                                                        options={formInitData?.broker?.map(bkr => ({
                                                            label: `${bkr.name} (${bkr.ib_name})`,
                                                            value: bkr._id,
                                                            link: bkr.ib_link,
                                                            server: bkr.broker_server_name
                                                        }))}
                                                    /> */}
                          <Input size="large" placeholder="Enter Broker Name" />
                        </Form.Item>
                      </Col>
                      <Col sm={12} xs={24}>
                        <Form.Item label="Server (Broker)" name="brokerServer" rules={[{ required: true, message: "Please Enter broker server!" }]}>
                          <Input size="large" placeholder="Enter Broker Server" />
                        </Form.Item>
                      </Col>
                      <Col sm={12} xs={24}>
                        <Form.Item label="Account Number" name="accountNumber" rules={[{ required: true, message: "Please Enter account number!" }]}>
                          <Input size="large" placeholder="Enter Account Number" />
                        </Form.Item>
                      </Col>
                      <Col sm={12} xs={24}>
                        <Form.Item
                          label="Master Password"
                          name="masterPassword"
                          rules={[{ required: true, message: "Please Enter master password!" }]}
                        >
                          <Input.Password size="large" placeholder="Enter Master Password" />
                        </Form.Item>
                      </Col>
                      <Col sm={12} xs={24}>
                        <Form.Item
                          label="Investor Password"
                          name="investorPassword"
                          rules={[{ required: true, message: "Please Enter investor password!" }]}
                        >
                          <Input.Password size="large" placeholder="Enter Investor Password" />
                        </Form.Item>
                      </Col>
                      <Col sm={12} xs={24}>
                        <Form.Item label="Deposit Amount" name="depositAmount">
                          <Input size="large" placeholder="Enter Deposit Amount" />
                        </Form.Item>
                      </Col>
                      {/* <Col span={12}>
                                                <Form.Item label="Portal Link" name="portalLink">
                                                    <Input size='large' placeholder="Enter Portal Link" />
                                                </Form.Item>
                                            </Col> */}
                                            {/* <Col span={12}>
                                                <Form.Item label="Password (Broker Portal)" name="portalPassword">
                                                    <Input.Password size='large' placeholder="Enter Portal Password" />
                                                </Form.Item>
                                        </Col> */}
                                        {!wlId && <Col sm={12} xs={24}>
                                    <Form.Item label="Vps Server" name="vpsServer" rules={[{required: true,message: 'Please select VPS server!'}]}>
                                        <Select size='large' placeholder="Select Vps Server" showSearch options={formInitData?.server?.map(srvr => ({
                                            value: srvr._id,
                                            label: srvr.vps_ip
                                        }))} filterOption={(input,option) =>
                                            option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                                            option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        } />
                                    </Form.Item>
                                </Col>}
                                        </>}
                                        <Col sm={24} xs={24}>
                                    <Form.Item
                                        name="tcAgreement"
                                        valuePropName="checked"
                                        rules={[
                                            {
                                              validator: (_, value) =>
                                                value ? Promise.resolve() : Promise.reject(new Error('Should accept agreement')),
                                            },
                                          ]}
                                    >
                                        <Flex align='start' gap={5}>
                                            <Checkbox onChange={(e) => setIsChecked(e.target.checked)} checked={isChecked}/>
                                            <Typography.Paragraph
                                                ellipsis={{
                                                rows: 2,
                                                    expandable: 'collapsible',
                                                }}
                                            >
                                                An investment in derivatives may mean investors may lose an amount even greater than their original investment. Anyone wishing to invest in any of the products mentioned in {whiteLabel?.name} should seek their own financial or professional advice. EA (AI) Trading may not be suitable for everyone and involves the risk of losing part or all of your money. Trading in the financial markets has large potential rewards, but also large potential risk. You must be aware of the risks and be willing to accept them in order to invest in the markets. Don't invest and trade with money which you can't afford to lose. CFD Trading are not allowed in some countries, before investing your money, make sure whether your country is allowing this or not. You are strongly advised to obtain independent financial, legal advice before proceeding with any currency or spot metals trade. Nothing in this site should be read or construed as constituting advice on the part of {whiteLabel?.name} Limited or any of its affiliates, directors, officers or employees.
                                            </Typography.Paragraph>
                                        </Flex>
                                    </Form.Item>
                                </Col>
                                {isChecked &&
                                    <Col sm={24} xs={24}>
                                        <Form.Item
                                            label={`What percentage of risk are you willing to allow ${whiteLabel?.name} to take with your capital in your live trading account? Please select the agreed percentage.`}
                                            name="risk_pr"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please Select Percentage'
                                                }
                                            ]}
                                            extra="This is the maximum percentage of your account balance that you are willing to lose. If this limit is reached, all open trades will close, and the remaining balance will be saved."
                                        >
                                            <Select
                                                size='large'
                                                placeholder="Select a Percentage"
                                                
                                                options={[
                                                    // {
                                                    //     label: "40%",
                                                    //     value: 40
                                                    // },
                                                    // {
                                                    //     label: "50%",
                                                    //     value: 50
                                                    // },
                                                    {
                                                        label: "60%",
                                                        value: 60
                                                    },
                                                    {
                                                        label: "80%",
                                                        value: 80
                                                    },
                                                    {
                                                        label: "100%",
                                                        value: 100
                                                    },
                                                ]}
                                            />
                                        </Form.Item>
                                    </Col>
                                }
                                </Row>
                                <Button type="default" htmlType="submit" className='submit-btn' block size='large' loading={isLoading}>
                                    Submit
                                </Button>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
const mapStateToProps = ({ loading }) => {
  const { isLoading } = loading;
  return { isLoading };
};
export default connect(mapStateToProps, {})(UserRegistration);
